import { type AstNode } from "./types";

export const astToString = (ast: AstNode): string => {
  if (["variable", "number"].includes(ast.type)) {
    return `{${ast.value}}`;
  } else if (ast.type === "operator") {
    const leftStr = astToString(ast.left);
    const rightStr = astToString(ast.right);
    return `(${leftStr}${ast.value}${rightStr})`;
  } else {
    throw new Error("Invalid AST node type: " + (ast as AstNode).type);
  }
};

export const astToDisplayString = (ast: AstNode): string => {
  if (["variable", "number"].includes(ast.type)) {
    return String(ast.value);
  } else if (ast.type === "operator") {
    const leftStr = astToDisplayString(ast.left);
    const rightStr = astToDisplayString(ast.right);
    const shouldIncludeParenthesis = ["*", "/"].includes(ast.value);
    return shouldIncludeParenthesis
      ? `(${leftStr}) ${ast.value} (${rightStr})`
      : `${leftStr} ${ast.value} ${rightStr}`;
  } else {
    throw new Error("Invalid AST node type: " + (ast as AstNode).type);
  }
};

export const astToTokens = (ast: AstNode): string[] => {
  if (["variable", "number"].includes(ast.type)) {
    return [ast.value];
  } else if (ast.type === "operator") {
    const leftStr = astToTokens(ast.left);
    const rightStr = astToTokens(ast.right);
    return ["(", ...leftStr, ast.value, ...rightStr, ")"];
  } else {
    throw new Error("Invalid AST node type: " + (ast as AstNode).type);
  }
};
